import { Grid, TextField } from '@mui/material';

export const StepPoints = ({ points, setPoints, error }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <TextField
          label="امتیاز این گام"
          value={points.reward}
          onChange={(e) => {
            setPoints((p) => {
              if (!!e.target.valueAsNumber) {
                return { ...p, reward: e.target.valueAsNumber };
              } else {
                return { ...p, reward: 0 };
              }
            });
          }}
          fullWidth
          type="number"
          error={error && points.reward === 0}
          inputProps={{ min: 0 }}
          autoComplete="off"
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="حد نصاب امتیاز"
          value={points.required}
          onChange={(e) => {
            setPoints((p) => {
              if (!!e.target.valueAsNumber) {
                if (p.reward >= e.target.valueAsNumber) {
                  return { ...p, required: e.target.valueAsNumber };
                } else {
                  return { ...p, required: p.required };
                }
              } else {
                return { ...p, required: 0 };
              }
            });
          }}
          fullWidth
          type="number"
          error={error && (points.required === 0 || points.required > points.reward)}
          inputProps={{ max: points.reward, min: 0 }}
          autoComplete="off"
          disabled={points.reward === 0}
        />
      </Grid>
    </Grid>
  );
};
